import { render, staticRenderFns } from "./TaxiTransactionsCard.vue?vue&type=template&id=75c5f0ba"
import script from "./TaxiTransactionsCard.vue?vue&type=script&lang=js"
export * from "./TaxiTransactionsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports